import React from "react";
import { Flame, Snowflake, Sparkles, Cloud, Zap, Heart } from "lucide-react";

export const VIBES = {
  fire: { label: "Tutkulu", icon: Flame, color: "#FF3B30", bg: "#FFE0DC" },
  ice: { label: "Soğuk", icon: Snowflake, color: "#3AA0FF", bg: "#DCEEFF" },
  playful: { label: "Oyuncu", icon: Sparkles, color: "#CC9F00", bg: "#FFF7C2" },
  sad: { label: "Hüzünlü", icon: Cloud, color: "#7A7A9F", bg: "#E5E5F0" },
  urgent: { label: "Acil", icon: Zap, color: "#FF7A00", bg: "#FFE7CC" },
  romantic: { label: "Romantik", icon: Heart, color: "#E43385", bg: "#FFD9E8" },
};

export function getVibe(key) {
  return VIBES[key] || null;
}

export function VibePicker({ value, onChange }) {
  return (
    <div className="flex items-center gap-1.5 flex-wrap">
      <button
        type="button"
        onClick={() => onChange(null)}
        data-testid="vibe-clear-btn"
        className={`border-hard-2 rounded-full px-2.5 py-1 text-[11px] font-black uppercase tracking-widest press-btn ${!value ? "bg-[#0A0A0A] text-white" : "bg-white"}`}
      >
        Yok
      </button>
      {Object.entries(VIBES).map(([key, v]) => {
        const Icon = v.icon;
        const active = value === key;
        return (
          <button
            key={key}
            type="button"
            data-testid={`vibe-${key}-btn`}
            onClick={() => onChange(active ? null : key)}
            className={`border-hard-2 rounded-full px-2.5 py-1 text-[11px] font-black uppercase tracking-widest press-btn flex items-center gap-1 ${active ? "shadow-hard-sm" : ""}`}
            style={{ background: active ? v.bg : "white", color: active ? v.color : "#0A0A0A" }}
          >
            <Icon strokeWidth={3} className="w-3 h-3" />
            {v.label}
          </button>
        );
      })}
    </div>
  );
}
